import React from "react";
import useChatApp from "../../hooks/useChatApp";

function ChatApp({children})  {
    useChatApp()

    return <>{children}</>
}

export default ChatApp